<xm-diagnosis-widget-view
  [items]="diagnosisItems()"
  [title]="title()"
  [searchFn]="searchDiagnosisCodes$"
  [canAdd]="canAdd()"
  [canDelete]="canDelete()"
  [isProcessing]="isProcessing()"
  [usePrimaryText]="settings?.themeWidgetText"
  (itemAdded)="onItemAdded($event)"
  (itemRemoved)="onItemRemoved($event)">
</xm-diagnosis-widget-view>
